import { createListenerMiddleware } from '@reduxjs/toolkit';

import { isFreeBetPlaced, rawTotalBet } from '../../../utils/bets';
import { postClaimBonusAction } from '../../apiActions/fetchBonusPromotionAction';
import type { CoreRootState } from '../../CoreStore';
import { ChipTypes } from '../chips/types';

import { betActions, pushAutoplayBet } from './slice';

export const betMiddleware = createListenerMiddleware<CoreRootState>();

betMiddleware.startListening({
  predicate: (_action, currentState, originalState) => {
    const currentBetStack = currentState.bets.betStack;
    const originalBetStack = originalState.bets.betStack;
    return currentBetStack !== originalBetStack;
  },
  effect: (_action, { dispatch, getState }) => {
    const state = getState();
    const bets = state.bets.betStack?.[state.bets.betStack.length - 1];

    const totalBet = bets ? rawTotalBet(bets.betSpots) : 0;
    dispatch(betActions.setRawTotalBet(totalBet));
    const betType = isFreeBetPlaced(bets?.betSpots) ? ChipTypes.FreeChip : ChipTypes.CasinoChip;
    const placedBetType = totalBet > 0 ? betType : '';
    dispatch(betActions.setPlacedBetType(placedBetType));
  },
});

betMiddleware.startListening({
  actionCreator: pushAutoplayBet,
  effect: (action, { dispatch }) => {
    dispatch(betActions.pushBet(action.payload));
  },
});

betMiddleware.startListening({
  actionCreator: postClaimBonusAction.fulfilled,
  effect: (action, { dispatch, getState }) => {
    const state = getState();
    if (isFreeBetPlaced(state.bets.lastBet?.betSpots)) {
      dispatch(betActions.clearLastBets());
    }
  },
});
